// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__1wGxx","Open":"Card_Open__3drRO","Close":"Card_Close__26OEP"};